import { useMemo } from 'react'
import produce from 'immer'
import { useDataValue } from 'Simple/Data.js'
import { numberMoney } from 'Data/format.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let receivable = useDataValue({
    context: 'post_payment_info',
    path: 'receivable',
    viewPath: props.viewPath,
  })
  let payment_accounts = useDataValue({
    context: 'post_payment_info',
    path: 'payment_accounts',
    viewPath: props.viewPath,
  })
  let patient_due_amount = useDataValue({
    context: 'post_payment_info',
    path: 'patient_due_amount',
    viewPath: props.viewPath,
  })
  let payer_account_id = useDataValue({
    context: 'message',
    path: 'params.payer_account_id',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (!data) return data

    return produce(data, next => {
      // receivable balance has priority over payment account balance
      if (receivable) {
        next.amount = numberMoney(receivable.balance_amount || 0)
        next.receivable_id = receivable.id
        next.auto_apply_to_unpaid_receivables = false
      } else {
        next.amount = numberMoney(patient_due_amount || 0)
      }

      let payment_account_id = receivable
        ? receivable.payment_account_id
        : payer_account_id
      let payment_account =
        // 1. match the account against what the UI sent
        payment_accounts.find(
          item => item.data.payment_account_id === payment_account_id
        )
      // // 2. find the first one that isn't insurance
      // payment_accounts.find(item => !item.data.insured_id) ||
      // // 3. get the first one
      // payment_accounts[0]
      if (payment_account) {
        next.payment_account.selected_id = payment_account.id
        next.payment_account.data = payment_account.data
      }
    })
  }, [data, receivable, payer_account_id, payment_accounts, patient_due_amount])
}
